// src/components/home/PostContent.tsx
import React from 'react';
 
interface PostContentProps {
  darkMode: boolean;
  content: string;
}
 
export const PostContent: React.FC<PostContentProps> = ({ darkMode, content }) => {
  return (
    <div className="px-5 pb-4">
      <p
        className="text-sm leading-relaxed"
        style={{ color: darkMode ? 'rgba(240,250,250,0.85)' : '#0d1a1a' }}
      >
        {content}
      </p>
    </div>
  );
};